import { graphql } from "gatsby";
import React from "react";
import { find, isEmpty } from "lodash";

import { useTranslationContext } from "~/context/TranslationContext";

import { isBrowser } from "~/utilities/helpers";

import Footer from "~/components/Footer";

const FooterBlock = ({ data, pageCode }) => {
    const { activeCode } = useTranslationContext();
    const translatedFooter = find(data?.footer?.nodes, {
        languageCode: isBrowser ? activeCode : pageCode,
    });
    const englishFooter = find(data?.footer?.nodes, { languageCode: "en" });
    const footer = isEmpty(translatedFooter) ? englishFooter : translatedFooter;

    const socialLinks = footer?.components?.socialLinks || [];
    const footerFormInfo = footer?.components?.footerForm || {};

    const navLinks = footer?.components?.bottomNavigation || [];
    const secondaryNavLinks = footer?.components?.legalLinks || [];
    const copyright = footer?.components?.copyright || "";

    return (
        <Footer
            {...{
                footerFormInfo,
                navLinks,
                secondaryNavLinks,
                socialLinks,
                copyright,
            }}
        />
    );
};

export default FooterBlock;

export const query = graphql`
    query FooterQuery {
        footer: allWpNavigation {
            nodes {
                languageCode
                components {
                    bottomNavigation {
                        linkLabel
                        linkUrl
                    }
                    footerForm {
                        buttonIcon
                        buttonLabel
                        formId
                    }
                    legalLinks {
                        linkLabel
                        linkUrl
                    }
                    socialLinks {
                        icon
                        linkUrl
                        screenReaderText
                        isPopup
                        popupImage {
                            altText
                            title
                            sourceUrl
                            localFile {
                                childImageSharp {
                                    gatsbyImageData
                                }
                            }
                        }
                    }
                    copyright
                }
            }
        }
    }
`;
